<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()

const getToastColor = (type: string) => {
  switch (type) {
  case 'success': return 'success'
  case 'error': return 'error'
  case 'warning': return 'warning'
  case 'info': return 'info'
  default: return 'primary'
  }
}

const getToastIcon = (type: string) => {
  switch (type) {
  case 'success': return 'tabler-circle-check'
  case 'error': return 'tabler-circle-x'
  case 'warning': return 'tabler-alert-circle'
  case 'info': return 'tabler-info-circle'
  default: return 'tabler-bell'
  }
}
</script>

<template>
  <div class="toast-container">
    <VSnackbar
      v-for="toast in toasts"
      :key="toast.id"
      :model-value="true"
      :color="getToastColor(toast.type)"
      :timeout="toast.persistent ? -1 : toast.duration"
      location="top right"
      class="mb-2"
      @update:model-value="removeToast(toast.id)"
    >
      <div class="d-flex align-center">
        <VIcon
          :icon="getToastIcon(toast.type)"
          class="me-3"
          size="20"
        />
        <div class="flex-grow-1">
          <div
            v-if="toast.title"
            class="font-weight-medium"
          >
            {{ toast.title }}
          </div>
          <div class="text-body-2">
            {{ toast.message }}
          </div>
        </div>
        <VBtn
          icon
          variant="text"
          size="small"
          @click="removeToast(toast.id)"
        >
          <VIcon
            icon="tabler-x"
            size="16"
          />
        </VBtn>
      </div>
    </VSnackbar>
  </div>
</template>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
}
</style>
